import { MARQUEE_WORDS } from "../../lib/content";

const Row = () => (
  <div className="flex shrink-0 items-center" aria-hidden="true">
    {MARQUEE_WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-display text-4xl font-medium italic-none tracking-tight text-forest sm:text-6xl lg:text-7xl">{w}</span>
        <svg viewBox="0 0 24 24" className="h-7 w-7 text-gold sm:h-10 sm:w-10"><circle cx="12" cy="12" r="5" fill="currentColor" /><g stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1" /></g></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Áreas de atuação" data-testid="editorial-marquee" className="relative overflow-hidden border-y border-forest/10 bg-paper py-10 sm:py-14">
    <p className="sr-only">{MARQUEE_WORDS.join(", ")}</p>
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
